module.exports = __webpack_public_path__ + "WS_Loader.gif";